const index = () => import(  './index');
const pendingList = () => import(  './pendingList');


const WORKBENCH = [
  {
    path: 'workbench',
    name: 'workbench',
    component: index,
    meta: {
      title: '首页'
    }
  },
  {
    path: 'pendingList',
    name: 'pendingList',
    component: pendingList,
    meta: {
      title: '代办列表'
    }
  },
];
export default WORKBENCH;